import React from 'react'
import {
  Spin,
  Button,
  DatePicker,
  Table,
  Select,
  Input,
  Pagination
} from 'antd'
import classnames from 'classnames'
import styles from './complaint-information-inquiry.module.less'
import './index.less'
import common from '@/public/common'
import { ajaxApi } from '@/server/index'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { outputMoney, outformat, getCookieNew, getCookie, setCookieNew } from '@/public/utils'
import { getParmUrl } from '../../public/utils'
import { getSid } from "@/public/utils";
moment.locale('zh-cn')
const { RangePicker } = DatePicker
const { Option } = Select
class ComplaintInformationInquiry extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      spinLoading: false,
      total: 0,
      paramData: {
        'supplier_code':getCookieNew('supplier_code'),
        'refund_code': '',
        'category_ids': [],
        'brand_ids': [],
        'begin_compliant_time': null,
        'end_compliant_time': null,
        'begin_add_time': null,
        'end_add_time': null,
        'search_item': '',
        'page_num': 1,
        'page_size': 10,
        'sort': 'desc'
      },
      tableData: [],
      categoryArr: [],
      brandArr: []
    }
  }
  componentDidMount () {
    let {paramData} = this.state
    this.getQueryBrand()
    this.getQueryCategory()

    if (getParmUrl('PROCode') !== '') {
      paramData.refund_code = getParmUrl('PROCode')
    }
    this.setState({
      paramData
    }, () => {
      this.getTableList()
    })
  }

  getModerId = () => {
    var moder_id = getCookie('supplier_company_code')||null
    return moder_id
  }
  // 列表数据CT201118000001
  getTableList = async () => {
    let {paramData} = this.state
    this.setState({
      spinLoading: false
    })
    try {
      let res = await ajaxApi({
        // url: common.scpUrl + 'work-order/query-supplier-complaint',
        url: `${common.SapUrl}po-return/query-complaint-detail/by-supplier`,
        params: {
          admin_id: this.getModerId(),
          sid: getSid(),
          ...paramData
        }
      })
      this.setState({
        spinLoading: false
      })
      if (res.data.code === '0') {
        if (res.data.data.list.length !== 0) {
          res.data.data.list.map((item, index) => {
            item.key = index
          })
          this.setState({
            tableData: res.data.data.list,
            total: res.data.data.total
          })
        } else {
          this.setState({
            tableData: [],
            total: 0
          })
        }
      }
    } catch (e) {
      this.setState({
        spinLoading: false,
        tableData: [],
        total: 0
      })
      console.log(e)
    }
  }

  // 查询品牌
  getQueryBrand = async () => {
    let {brandArr} = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-brand',
        params: {}
      })
      if (res.status === 200 && res.data) {
        this.setState({
          brandArr: res.data.data
        })
      } else {
        this.setState({
          brandArr: []
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 查询类别
  getQueryCategory = async () => {
    let { categoryArr } = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-category',
        params: {}
      })
      if (res.status === 200 && res.data) {
        this.setState({
          categoryArr: res.data.data
        })
      } else {
        this.setState({
          categoryArr: []
        })
      }
    } catch (e) {
      console.log(e)
    }
  };

  // 获取下拉框的值
  handelChangeSource=(e, name) => {
    let {paramData} = this.state
    paramData[name] = e
    this.setState({
      paramData
    }, () => {
      // console.log(this.state.paramData)
    })
  }

  // 获取时间的值
  handleChangeDate=(e, name) => {
    let {paramData} = this.state
    paramData[name] = e ? moment(e).valueOf() : null
    if (e) {
      if (name === 'begin_compliant_time') {
        paramData[name] = moment(moment(e).format('YYYY-MM-DD 00:00:00')).valueOf()
      } else {
        paramData[name] = moment(moment(e).format('YYYY-MM-DD 23:59:59')).valueOf()
      }
    } else {
      paramData[name] = null
    }
    this.setState({
      paramData
    }, () => {
      // console.log(this.state.paramData)
    })
  }
  // 变更创建时间
  handleChangeCreateDate=(e, name) => {
    let {paramData} = this.state
    paramData[name] = e ? moment(e).valueOf() : null
    if (e) {
      if (name === 'begin_add_time') {
        paramData[name] = moment(moment(e).format('YYYY-MM-DD 00:00:00')).valueOf()
      } else {
        paramData[name] = moment(moment(e).format('YYYY-MM-DD 23:59:59')).valueOf()
      }
    } else {
      paramData[name] = null
    }
    this.setState({
      paramData
    }, () => {
      // console.log(this.state.paramData)
    })
  }

  // 获取输入框的值
  handleChangeInput=(e, name) => {
    let {paramData} = this.state
    paramData[name] = e.target.value
    this.setState({
      paramData
    }, () => {
      // console.log(this.state.paramData)
    })
  }

  // 排序
  handleSort=(pagination, filters, sorter) => {
    let {paramData} = this.state
    if (Object.keys(sorter).length === 0) {
      paramData.sort = 'desc'
      this.setState({
        paramData
      }, () => {
        this.getTableList()
      })
    } else {
      paramData.sort = sorter.order === 'descend' ? 'desc' : 'asc'
      this.setState({
        paramData
      }, () => {
        this.getTableList()
      })
    }
  }

  // 查询
  handleSearch=() => {
    let {paramData} = this.state
    paramData.page_num = 1
    this.setState({
      paramData
    }, () => {
      this.getTableList()
    })
  }

  // 重置
  handleReset=() => {
    let {paramData} = this.state
    paramData.refund_code = ''
    paramData.category_ids = []
    paramData.brand_ids = []
    paramData.begin_compliant_time = null
    paramData.end_compliant_time = null
    paramData.begin_add_time = null
    paramData.end_add_time = null
    paramData.search_item = ''
    paramData.page_num = 1
    paramData.page_size = 10
    paramData.sort = 'desc'
    this.setState({
      paramData
    }, () => {
      this.getTableList()
    })
  }

  // 换页
  pageChage=(page, pagesize) => {
    let {paramData} = this.state
    paramData.page_num = page
    this.setState({
      paramData
    }, () => {
      this.getTableList()
    })
  }

  // 调整页数
  onShowSizeChange=(current, pageSize) => {
    try {
      let { paramData } = this.state
      paramData.page_size = pageSize
      paramData.page_num = current
      this.setState({
        paramData
      }, () => {
        this.getTableList()
      })
    } catch (error) {
      console.log(error)
    }
  }

  // 换页
  pageChage=(page, pagesize) => {
    let {paramData} = this.state
    paramData.page_num = page
    this.setState({
      paramData
    }, () => {
      this.getTableList()
    })
  }

  // 调整页数
  onShowSizeChange=(current, pageSize) => {
    try {
      let { paramData } = this.state
      paramData.page_size = pageSize
      paramData.page_num = current
      this.setState({
        paramData
      }, () => {
        this.getTableList()
      })
    } catch (error) {
      console.log(error)
    }
  }

  disabledStartDate = startValue => {
    let {paramData} = this.state
    const endValue = paramData.end_compliant_time
    if (!startValue || !endValue) {
      return false
    }
    return startValue.valueOf() > endValue.valueOf()
  }
  disabledEndDate = endValue => {
    let {paramData} = this.state
    const startValue = paramData.begin_compliant_time
    if (!endValue || !startValue) {
      return false
    }
    return endValue.valueOf() < startValue.valueOf()
  }

  // 打印
  handlePrint=() => {
    let {paramData} = this.state
    let params = JSON.parse(JSON.stringify(paramData))
    delete params.page_num
    delete params.page_size
    delete params.sort
    setCookieNew('printData', encodeURI(JSON.stringify(params)), 3)
    this.props.history.push({pathname: '/main/complaintinformationinquiry/nophysical-complaint-printing', query: {params: params}})
  }

  addM = (data) => {
    let phoneNum = data
    let phoneNum_ = phoneNum.substr(0, 3) + '****' + phoneNum.substr(7)
    return phoneNum_
  }

  //
  getDomZh=(value, type) => {
    let _value = value.split(',')
    if (type) {
      return (
        <div>
          { _value.map((item, index) => {
            return <div style={{marginBottom: '4px'}}>{item}</div>
          })}
        </div>
      )
    } else {
      return (
        <div>
          <span style={{float: 'left'}}>补发:</span>
          { _value.map((item, index) => {
            return <div style={{marginBottom: '4px'}}>{item}</div>
          })}
        </div>
      )
    }
  }

  // 字段合并
  fieldMerging=(value1, value2) => {
    let _value1
    let _value2
    let _index1
    let _index2
    let _value3 = []
    if (value1 && value2) {
      _value1 = value1.split(',')
      _value2 = value2.split(',')
      _index1 = _value1.length
      _index2 = _value2.length
      if (_index1 > _index2) {
        _value1.map(function (item, index) {
          _value3.push({
            name: item,
            value: _value2[index] ? _value2[index] : null
          })
        })
      } else if (_index1 === _index2) {
        _value1.map(function (item, index) {
          _value3.push({
            name: item,
            value: _value2[index] ? _value2[index] : null
          })
        })
      } else {
        _value2.map(function (item, index) {
          _value3.push({
            name: _value1[index] ? _value1[index] : null,
            value: item
          })
        })
      }
    } else if (value1 !== null) {
      _value1 = value1.split(',')
      _value1.map((item, index) => {
        _value3.push({
          name: item,
          value: null
        })
      })
    } else if (value2 !== null) {
      _value2 = value2.split(',')
      _value2.map((item, index) => {
        _value3.push({
          name: null,
          value: item
        })
      })
    } else {
      _value3 = []
    }
    console.log(_value3)
    if (_value3.length !== 0) {
      return (
        <div>
          {_value3.map((item, index) => {
            return (
              <div>
                <span>{item.name ? item.name : '-'}</span>
                <span>/</span>
                <span>{item.value ? item.value : '-'}</span>
              </div>
            )
          })}
        </div>
      )
    } else {
      return (
        <div>
          <span>-</span>
          <span>/</span>
          <span>-</span>
        </div>
      )
    }
  }

  render () {
    const columns = [
      {
        title: '类别',
        dataIndex: 'category_name',
        key: 'category_name',
        fixed: 'left',
        className: classnames([styles.rowname])
      },
      {
        title: '品牌',
        dataIndex: 'brand_name',
        key: 'brand_name',
        width: 50,
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.brand_name ? record.brand_name : '-'}</span>
      },
      {
        title: '商品编码',
        dataIndex: 'item_code',
        key: 'item_code',
        width: 60,
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.item_code ? record.item_code : '-'}</span>
      },
      {
        title: '货品编码',
        dataIndex: 'product_code',
        key: 'product_code',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.product_code ? record.product_code : '-'}</span>
      },
      {
        title: '货品名称',
        dataIndex: 'product_name',
        key: 'product_name',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.product_name ? record.product_name : '-'}</span>
      },
      {
        title: '镜片类型',
        dataIndex: 'sub_category_name',
        key: 'sub_category_name',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.sub_category_name ? record.sub_category_name : '-'}</span>
      },
      {
        title: '花色',
        dataIndex: 'color',
        key: 'color',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.color ? record.color : '-'}</span>
      },
      {
        title: '抛期',
        dataIndex: 'discard_cycle_name',
        key: 'discard_cycle_name',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.discard_cycle_name ? record.discard_cycle_name : '-'}</span>
      },
      {
        title: '基弧/度数',
        dataIndex: 'contact_arc',
        key: 'contact_arc',
        className: classnames([styles.rowname]),
        render: (text, record) => <span><span>{record.contact_arc ? record.contact_arc : '-'}</span><span>{record.degree ? '/' + record.degree : '-'}</span></span>
      },
      {
        title: '批次',
        dataIndex: 'batch_no',
        key: 'batch_no',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.batch_no ? record.batch_no : '-'}</span>
      },
      {
        title: '投诉数量（盒）',
        dataIndex: 'complaint_count',
        key: 'complaint_count',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.complaint_count ? record.complaint_count : '-'}</span>
      },
      {
        title: '下单时间',
        dataIndex: 'order_time',
        key: 'order_time',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.order_time ? moment(record.order_time).format('YYYY-MM-DD HH:mm:ss') : '-'}</span>
      },
      {
        title: '投诉时间',
        dataIndex: 'complaint_time',
        key: 'complaint_time',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.complaint_time ? moment(record.complaint_time).format('YYYY-MM-DD HH:mm:ss') : '-'}</span>
      },
      {
        title: '投诉原因一级/投诉原因二级',
        dataIndex: 'complaint_reason',
        key: 'complaint_reason',
        width: 180,
        className: classnames([styles.rowname]),
        render: (text, record) => (
          <div>
            <div>{record.complaint_reason_category}</div>
            <div>{text}</div>
          </div>
        ),
      },
      {
        title: '消费者姓名',
        dataIndex: 'customer_name',
        key: 'customer_name',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.customer_name ? record.customer_name : '-'}</span>
      },
      {
        title: '消费者地址',
        dataIndex: 'address',
        key: 'address',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.address ? record.address : '-'}</span>
      },
      {
        title: '消费者电话',
        dataIndex: 'customer_phone',
        key: 'customer_phone',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.customer_phone ? this.addM(record.customer_phone) : '-'}</span>
      },
      // {
      //   title: '退货还是换货',
      //   dataIndex: 'is_exchange',
      //   key: 'is_exchange',
      //   className: classnames([styles.rowname]),
      //   render: (text, record) => <span>{record.is_exchange ? record.is_exchange === 1 ? '换货' : '退货' : record.is_exchange === 0 ? '退货' : '-'}</span>
      // },
      // {
      //   title: <sapn>
      //     <div>补发快递公司</div>
      //     <div>快递单号</div>
      //   </sapn>,
      //   dataIndex: 'delivery_company',
      //   key: 'delivery_company',
      //   width: 110,
      //   className: classnames([styles.rowname]),
      //   render: (text, record) => <span>
      //     <div>{this.fieldMerging(record.delivery_company, record.delivery_code)}</div>
      //     {/* <div>{record.delivery_company ? this.getDomZh(record.delivery_company, 'delivery_company') : '-'}</div>
      // <div>{record.delivery_code ? this.getDomZh(record.delivery_code, 'delivery_company') : '-'}</div> */}
      //   </span>
      // },
      {
        title: '销售渠道',
        dataIndex: 'source_channel_name',
        key: 'source_channel_name',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.source_channel_name ? record.source_channel_name : '-'}</span>
      },
      {
         title: '渠道单号',
        dataIndex: 'channel_order_code',
        key: 'channel_order_code',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.channel_order_code ? record.channel_order_code : '-'}</span>
      },
      {
        title: '创建时间',
        dataIndex: 'add_time',
        key: 'add_time',
        className: classnames([styles.rowname]),
        render: (text, record) => <span>{record.add_time ? moment(record.add_time).format('YYYY-MM-DD HH:mm:ss') : '-'}</span>
      },
      // {
      //   title: <sapn>
      //     <div> ERP单号</div>
      //     <div>补发ERP单号</div>
      //   </sapn>,
      //   dataIndex: 'erp_code',
      //   key: 'erp_code',
      //   width: 90,
      //   className: classnames([styles.rowname]),
      //   render: (text, record) => <span>

      //     <div style={{width: 90}}>{record.erp_code ? record.erp_code : '-'}</div>
      //     <div style={{width: 90}}>{record.exchange_code ? this.getDomZh(record.exchange_code) : '-'}</div>
      //   </span>
      // },
      // {
      //   title: '工单号',
      //   dataIndex: 'work_order_code',
      //   key: 'work_order_code',
      //   fixed: 'right',
      //   className: classnames([styles.rowname]),
      //   render: (text, record) => <span>{record.work_order_code ? record.work_order_code : '-'}</span>
      // }
    ]
    return (
      <div className="complainInfo">
        <Spin spinning={this.state.spinLoading}>
          <div className="search">
            <section>
              <span className={styles.publicspan}>商品编码/货品编码：</span>
              <Input
                onKeyDown={this.onKeyup}
                placeholder="请输入"
                name="search_item"
                value={this.state.paramData.search_item}
                onChange={(e) => this.handleChangeInput(e, 'search_item')}
                style={{ width: 196, marginRight: '16px' }}
              />
              <span className={styles.publicspan}>商品品牌：</span>
                <Select
                  showSearch
                  mode="multiple"
                  onKeyDown={this.onKeyup}
                  style={{ width: 196, marginRight: '16px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={this.state.paramData.brand_ids}
                  onChange={(e) => this.handelChangeSource(e, 'brand_ids')}
                >
                  <Option key={0} name='brand_ids' value=''>请选择</Option>
                  {this.state.brandArr || this.state.brandArr.length === 0 ? this.state.brandArr.map((item, index) => (
                    <Option key={index + 1} name='brand_ids' value={item.id}>{item.name}</Option>
                  )) : null}
                </Select>

                <span className={styles.publicspan}>类别：</span>
                <Select
                  showSearch
                  mode="multiple"
                  onKeyDown={this.onKeyup}
                  style={{ width: 196, marginRight: '16px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={this.state.paramData.category_ids}
                  onChange={(e) => this.handelChangeSource(e, 'category_ids')}
                >
                  <Option key={0} name='category_ids' value=''>请选择</Option>
                  {this.state.categoryArr || this.state.categoryArr.length === 0 ? this.state.categoryArr.map((item, index) => (
                    <Option key={index + 1} name='category_ids' value={item.id}>{item.name}</Option>
                  )) : null}
                </Select>

              
              <span style={{float: 'right'}}>
                <Button
                  type="primary"
                  shape="round"
                  style={{ marginLeft: '28px' }}
                  onKeyDown={this.onKeyup}
                  onClick={this.handleSearch}
                >
        查询
                </Button>
                <Button
                  type=""
                  shape="round"
                  style={{ margin: '0px 8px' }}
                  onClick={this.handleReset}
                >
        重置
                </Button>
              </span>
              <section style={{marginTop: '15px'}}>
                <span className={styles.publicspan}>创建时间：</span>
                <DatePicker
                  onOpenChange={this.handleOpenChange}
                  format="YYYY-MM-DD"
                  style={{ width: '196px' }}
                  disabledDate={this.disabledStartDate}
                  onPanelChange={this.handlePanelChange}
                  onChange={(e) => this.handleChangeCreateDate(e, 'begin_add_time', '责任')}
                  value ={this.state.paramData.begin_add_time ? moment(this.state.paramData.begin_add_time) : null}
                />
                <span style={{margin: '0px 4px'}}>~</span>
                <DatePicker
                  onOpenChange={this.handleOpenChange}
                  format="YYYY-MM-DD"
                  style={{ width: '196px' }}
                  disabledDate={this.disabledEndtDate}
                  onPanelChange={this.handlePanelChange}
                  onChange={(e) => this.handleChangeCreateDate(e, 'end_add_time', '责任')}
                  value ={this.state.paramData.end_add_time ? moment(this.state.paramData.end_add_time) : null}
                />
                <span className={styles.publicspan}>投诉时间：</span>
                <DatePicker
                  onOpenChange={this.handleOpenChange}
                  format="YYYY-MM-DD"
                  style={{ width: '196px' }}
                  disabledDate={this.disabledStartDate}
                  onPanelChange={this.handlePanelChange}
                  onChange={(e) => this.handleChangeDate(e, 'begin_compliant_time', '责任')}
                  value ={this.state.paramData.begin_compliant_time ? moment(this.state.paramData.begin_compliant_time) : null}
                />
                <span style={{margin: '0px 4px'}}>~</span>
                <DatePicker
                  onOpenChange={this.handleOpenChange}
                  format="YYYY-MM-DD"
                  style={{ width: '196px' }}
                  disabledDate={this.disabledEndtDate}
                  onPanelChange={this.handlePanelChange}
                  onChange={(e) => this.handleChangeDate(e, 'end_compliant_time', '责任')}
                  value ={this.state.paramData.end_compliant_time ? moment(this.state.paramData.end_compliant_time) : null}
                />

              </section>

            </section>
          </div>
          <div className="body">
            <div> <Button
              type=""
              shape="round"
              style={{ margin: '4px 0px', marginBottom: '16px' }}
              onClick={this.handlePrint}
            >
             打印
            </Button></div>
            <Table
              bordered={false}
              onChange={this.handleSort}
              scroll={{x: '100%'}}
              rowKey={(record) => record.key}
              dataSource={this.state.tableData}
              pagination={false}
              columns={columns}
            ></Table>
            <div className={styles.page}>
              <span
                style={{
                  position: 'absolute',
                  left: '2px',
                  top: '-4px',
                  fontSize: '14px'
                }}
              >
                <span>共</span>
                <span>{this.state.total}</span>
                <span>条记录</span>
              </span>
              <Pagination
                current={this.state.paramData.page_num}
                showQuickJumper
                total={this.state.total}
                showSizeChanger
                onShowSizeChange={this.onShowSizeChange}
                onChange={this.pageChage}
              />
            </div>
          </div>
        </Spin>
      </div>
    )
  }
}
export default ComplaintInformationInquiry



// WEBPACK FOOTER //
// ./src/pages/complaintinformationinquiry/complaint-information-inquiry.js